import { FaDumbbell } from "react-icons/fa";
import { FiArrowRight } from "react-icons/fi";
import { WorkoutPlan } from "../../types";

interface TrainItemProps {
  data: WorkoutPlan;
  onClick?: (data: WorkoutPlan) => void;
}

function TrainItem({ data, onClick }: TrainItemProps) {
  return (
    <div
      onClick={() => (onClick ? onClick(data) : null)}
      className="rounded-lg p-3 flex flex-row justify-between items-center gap-2 select-none cursor-pointer w-full border border-stroke bg-gray-50 shadow-sm transition-all hover:shadow-md dark:border-strokedark dark:bg-meta-4"
    >
      <div className="flex flex-col justify-between gap-1 py-1">
        <span className="font-bold text-xs flex items-center gap-2 text-black dark:text-white">
          <FaDumbbell size={25} className="text-primary" />
          {data?.plan_name}
        </span>
      </div>
      <div className="flex flex-col">
        <FiArrowRight size={12} className="text-black dark:text-white" />
      </div>
    </div>
  );
}

export default TrainItem;
